import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "queue-widget"
}

import { ref, computed, onMounted, nextTick } from "vue";

const __default__ = {
  name: "QueueDefaultWidget",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    queueData: {},
    queueConfig: {},
    borderRadius: {},
    config: {}
  },
  setup(__props: any) {

const props = __props;

const headerRef = ref<HTMLElement | null>(null);
const widgetWidth = computed(() => props.config.width || 400);
const widgetHeight = computed(() => props.config.height || 400);
const rowCount = computed(() => props.queueData.length || 1);
const rowGap = 8;

const headerHeight = ref(50); 

onMounted(async () => {
  await nextTick();
  if (headerRef.value) {
    headerHeight.value = headerRef.value.getBoundingClientRect().height;
  }
});

const isFewRows = computed(() => rowCount.value <= 2);
const availableHeight = computed(() => widgetHeight.value - headerHeight.value);
const squareBoxSize = computed(() => {
  const w = widgetWidth.value / 2;
  const h = (availableHeight.value - (rowCount.value - 1) * rowGap) / rowCount.value;
  const base = Math.min(w, h);
  return isFewRows.value ? base * 0.5 : base;
});

const headerFontSize = computed(() => {
  return Math.max(35, Math.min(55, headerHeight.value / 15));
});

// const headerFontSize = computed(() => {
//   return Math.max(20, Math.min(100, headerHeight.value * 0.6));
// });

const ticketFontSize = computed(() => {
  return Math.max(40, Math.min(75, widgetWidth.value / 8));
});

return (_ctx: any,_cache: any) => {
  return (_ctx.queueData.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "queue-header",
          ref_key: "headerRef",
          ref: headerRef
        }, [
          _createElementVNode("div", {
            class: "header",
            style: _normalizeStyle({ 
        color: _ctx.queueConfig.numberHeaderColor,
        fontSize: headerFontSize.value + 'px !important'
      })
          }, _toDisplayString(_ctx.queueConfig.numberTxt.toUpperCase()), 5),
          _createElementVNode("div", {
            class: "header",
            style: _normalizeStyle({ 
        color: _ctx.queueConfig.counterHeaderColor,
        fontSize: headerFontSize.value + 'px !important'
      })
          }, _toDisplayString(_ctx.queueConfig.counterTxt.toUpperCase()), 5)
        ], 512),
        _createElementVNode("div", {
          class: _normalizeClass(["queue-body", { 'centered-few': isFewRows.value }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queueData, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "queue-row",
              style: _normalizeStyle(isFewRows.value ? { height: squareBoxSize.value + 'px' } : {})
            }, [
              _createElementVNode("div", {
                class: "ticket",
                style: _normalizeStyle({
            color: _ctx.queueConfig.numberTxtColor,
            background: _ctx.queueConfig.numberBgColor,
            borderRadius:
              typeof _ctx.borderRadius === 'number'
                ? _ctx.borderRadius + 'px'
                : _ctx.borderRadius,
            fontSize: ticketFontSize.value + 'px !important' 
          })
              }, _toDisplayString(item.ticket), 5),
              _createElementVNode("div", {
                class: "counter",
                style: _normalizeStyle({
            color: _ctx.queueConfig.counterTxtColor,
            background: _ctx.queueConfig.counterBgColor,
            fontSize: ticketFontSize.value + 'px !important' 
          })
              }, _toDisplayString(item.counter), 5)
            ], 4))
          }), 128))
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})